import { TestLevelsWithFilterQuery } from '@/__generated__/graphql';
import { ModalDropdown } from '@/components/common/Modal/components';
import { DropdownProps } from '@/components/common/Modal/components/ModalDropdown';
import { omit } from 'lodash-es';
import useTranslation from 'next-translate/useTranslation';
import React, { useCallback, useMemo } from 'react';

interface RankingTestLevelProps extends DropdownProps {
  selected?: string | null;
  onChange?: (value: string | undefined, id: string | undefined) => void;
  dataTestLevel?: TestLevelsWithFilterQuery;
}

function RankingTestLevel({ onChange, dataTestLevel, ...props }: RankingTestLevelProps) {
  const { t } = useTranslation('common');

  const provinces = useMemo(() => {
    if (dataTestLevel && dataTestLevel?.testLevels?.nodes) {
      return dataTestLevel?.testLevels?.nodes?.map((lv) => ({
        title: lv.name,
        value: lv.id.toString(),
      }));
    }
    return [];
  }, [dataTestLevel]);

  const handleChange = useCallback(
    (value: string | undefined, id: string | undefined) => {
      if (onChange) {
        onChange(value, id);
      }
    },
    [onChange],
  );

  return (
    <ModalDropdown
      items={provinces}
      hasSearchable
      focusOnOpen
      onSelect={handleChange}
      {...omit(props, 'items')}
      queryPlaceholder={t('label.test_level_description')}
      placeholder={t('label.test_level_description')}
      canClearSelected
    />
  );
}
export default RankingTestLevel;
